export default __webpack_public_path__ + "static/media/cxeer.6d46dcf6.svg";